import { motion } from "framer-motion";

const images = [
  "features-1-data-management.png",
  //"features-1-management.png",
  "features-1-multisource-import.png",
  "features-1-optimize-data.png",
  "features-2-analysis.png",
  "features-2-analyticalgorythms.png",
  "features-2-statistical-description.png",
  //"features-3-dashboard-and-document-mode.png",
  "features-3-report-creation.png",
  "features-3-reporting1.png",
  //"features-3-stylish-layouts.png",
  "features-4-deployment1.png",
  "features-4-edit-and-update.png",
  //"features-4-manage-and-feedback.png",
  //"features-4-report-creation.png",
  //"features-5-autopilot.png",
  "features-5-cloud.png",
  "features-5-live-planning.png",
  "features-5-publish1.png",
];

// Animation Variants
const imageVariants = {
  hidden: { opacity: 0, scaleY: 0, transformOrigin: "bottom" },
  visible: (i: number) => ({
    opacity: 1,
    scaleY: 1,
    transition: {
      duration: 0.3,
      delay: i * 0.1, // Stagger effect (each image appears one after the other)
      ease: "easeOut",
    },
  }),
};

export default function ImageBanner() {
  return (
    <div
      style={{ display: "flex", marginLeft: "1rem", marginTop: "2rem" }}
      className="images-banner"
    >
      {images.map((src, index) => (
        <motion.img
          key={src}
          custom={index}
          initial="hidden"
          animate="visible"
          variants={imageVariants}
          src={`/img/home/top-banner/${src}`}
          alt={src.replace(".png", "")}
          style={{
            width: "2.5rem",
            height: "2.5rem",
            marginRight: "0.15rem",
            transformOrigin: "bottom", // Ensures animation grows from bottom
            borderRadius: "0.25rem",
          }}
        />
      ))}
    </div>
  );
}
